import Vue from 'vue'
import VueRouter from 'vue-router'
import login from '../views/login/index'
import desktop from '../components/desktop/index'
Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'choose',
     component: () => import('@/views/login/choose'),
  },
  {
    path: '/chooseA',
    name: 'ChooseA',
     component: () => import('@/views/login/chooseA'),
  },
  {
    path: '/xd',
    name: 'xd',
     component: () => import('@/views/login/xd'),
  },
  {
    path: '/assist',
    name: 'assist',
     component: () => import('@/views/login/assist'),
  },
  {
    path: '/order',
    name: 'order',
     component: () => import('@/views/login/order'),
  },
  {
    path: '/orderSuccess',
    name: 'orderSuccess',
     component: () => import('@/views/login/orderSuccess'),
  },
  {
    path: '/dc',
    name: 'dc',
     component: () => import('@/views/login/dc'),
  },
  // {
  //   path: '/login',
  //   name: 'login',
  //   component: login
  // },
  {
    path: '/index',
    name: 'index',
     component: () => import('@/views/login/index'),
  },
  {
    path: '/scan',
    name: 'scan',
     component: () => import('@/views/login/scan'),
  },
  {
    path: '/home',
    name: 'home',
    component: () => import('@/views/home/index'),
    redirect: '/desktop',
    children:[
      {
        path: '/desktop',
        name: 'desktop',
        component: desktop
      },
      {
        path: '/faceList',
        name: 'face',
        component: () => import('@/components/face/index')
      },
      {
        path: '/faceLog',
        name: 'log',
        component: () => import('@/components/faceLog/index')
      }
	  
    ]
  }
]

const router = new VueRouter({
  routes
})


router.beforeEach((to,from,next)=>{
  // if(to.path === '/') return next()
  // let face_token = localStorage.getItem("face_token");
  // if (!face_token) return next("/")
  next()
})

// 导航守卫限制路由跳转
router.beforeEach((to, from, next) => { 
	if (to.path === '/') {
		next()
		var face_token = ''
		// localStorage.getItem("face_token");
	}
	if (!face_token) {
		next()
	} else {
		next('/')
	}
})
// router  要跟你引用的路由名称一致

export default router
